"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _info_icon = require("../../../atoms/icons/info_icon");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _text_input = require("../../text_input");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AddressInput = function AddressInput(_ref) {
  var register = _ref.register,
      type = _ref.type,
      errors = _ref.errors,
      required = _ref.required,
      country = _ref.country,
      name = _ref.name;
  var labelText = "Address ".concat(type);
  var finalName = "address".concat(type).concat(name);
  var requiredMessage = required;
  var error = false;
  var helperText = null;

  if (required) {
    requiredMessage = "Missing ".concat(labelText);
    helperText = '';
  }

  if (errors[finalName]) {
    error = true;
    helperText = errors[finalName].message;
  }

  var __validateInput = function __validateInput(inputValue) {
    if (country === 'NZ' && inputValue && inputValue.toLowerCase().replaceAll(' ', '').indexOf('pobox') !== -1) {
      return 'We are unable to deliver to PO Box addresses. Please enter another address';
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_text_input.TextInput, {
    type: "text",
    icon: error ? /*#__PURE__*/_react["default"].createElement(_info_icon.InfoIcon, {
      fill: "#ee0033"
    }) : null,
    label: labelText,
    name: finalName,
    error: error,
    register: register({
      required: required ? requiredMessage : false,
      validate: {
        checkInput: function checkInput(inputValue) {
          return __validateInput(inputValue);
        }
      }
    }),
    helperText: helperText,
    cypressClass: finalName
  });
};

AddressInput.propTypes = {
  /**
   * Object containing the errors from this input field.
   */
  errors: _propTypes["default"].object,

  /**
   * A boolean that determines if the address field is required or not.
   */
  required: _propTypes["default"].bool.isRequired,

  /**
   * A function that gets passed for the useForm hook from react-hook-form to register an input
   *
   */
  register: _propTypes["default"].func.isRequired,

  /**
   * Type of address. Only accepts numbers 1 2 or 3
   */
  type: _propTypes["default"].oneOf([1, 2, 3]).isRequired
};
AddressInput.defaultProps = {
  errors: {},
  register: function register() {},
  required: true,
  type: 1,
  name: ''
};
var _default = AddressInput;
exports["default"] = _default;